import { put, select, call, fork, takeLatest, all } from "redux-saga/effects";
import _ from "lodash";

import { authApiUpsellProvider, userApiProvider } from "../../lib/api/providers";
import {
  GET_UPSELL_TOKEN_FROM_GOOGLE,
  SET_UPSELL_TOKEN,
  GET_CURRENT_USER_INFOS,
  SET_CURRENT_USER_INFOS,
  AUTH_LOGOUT,
  GET_UPSELL_TOKEN_FROM_MICROSOFT,
  GET_SERVICES_LIST
} from "../types";

const getAuthState = state => state.auth;

const getUpsellTokenFromGoogleApi = action => {
  return authApiUpsellProvider
    .post("/login/google", {
      access_token: action.googleToken
    })
    .then((response = {}) => {
      return response.data;
    });
};

const getUpsellTokenFromMicrosoftApi = action => {
  return authApiUpsellProvider
    .post("/login/microsoft", {
      access_token: action.microsoftToken,
      email_username: action.emailUsername
    })
    .then((response = {}) => {
      return response.data;
    });
};

const getCurrentUserInfosApi = state => {
  return userApiProvider
    .get("/me", {
      headers: {
        Authorization: state.token
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

const postLogoutApi = state => {
  return authApiUpsellProvider
    .post(
      "/logout",
      {},
      {
        headers: {
          Authorization: state.token
        }
      }
    )
    .then((response = {}) => response.data);
};

function* getUpsellTokenFromGoogle(action) {
  try {
    const data = yield call(getUpsellTokenFromGoogleApi, action);

    localStorage.setItem("access_token", data.access_token);
    yield put({ type: SET_UPSELL_TOKEN, token: data.access_token });
  } catch (e) {
    console.log(e.message);
    localStorage.removeItem("access_token");
    localStorage.removeItem("currentClient");
    yield put({ type: SET_CURRENT_USER_INFOS, payload: {} });
    yield put({ type: SET_UPSELL_TOKEN, token: "" });
  }
}

function* getUpsellTokenFromMicrosoft(action) {
  try {
    const data = yield call(getUpsellTokenFromMicrosoftApi, action);

    localStorage.setItem("access_token", data.access_token);
    yield put({ type: SET_UPSELL_TOKEN, token: data.access_token });
  } catch (e) {
    console.log(e.message);
    localStorage.removeItem("access_token");
    localStorage.removeItem("currentClient");
    yield put({ type: SET_CURRENT_USER_INFOS, payload: {} });
    yield put({ type: SET_UPSELL_TOKEN, token: "" });
  }
}

function* getCurrentUserInfos() {
  try {
    const state = yield select(getAuthState);
    const data = yield call(getCurrentUserInfosApi, state);
    yield put({ type: GET_SERVICES_LIST });

    if (!_.isEmpty(data.clients)) {
      const sortedClients = data.clients
        .sort((a, b) => a.id - b.id)
        .map(client => ({ ...client, display: `C${client.id} ${client.label}` }));

      data.clients = sortedClients;
      yield put({ type: SET_CURRENT_USER_INFOS, payload: data });
    } else {
      localStorage.removeItem("access_token");
      localStorage.removeItem("currentClient");

      yield put({ type: SET_CURRENT_USER_INFOS, payload: {} });
      yield put({ type: SET_UPSELL_TOKEN, token: "" });
    }
  } catch (e) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("currentClient");
    yield put({ type: SET_CURRENT_USER_INFOS, payload: {} });
    yield put({ type: SET_UPSELL_TOKEN, token: "" });
  }
}

function* postLogout() {
  try {
    const state = yield select(getAuthState);
    call(postLogoutApi, state);

    localStorage.removeItem("access_token");
    localStorage.removeItem("currentClient");
    yield put({ type: SET_CURRENT_USER_INFOS, payload: {} });
    yield put({ type: SET_UPSELL_TOKEN, token: "" });
    window.location.href = "/";
    window.location.reload(true);
  } catch (e) {
    console.log(e.message);
  }
}

function* watchGetUpsellTokenFromGoogle() {
  yield takeLatest(GET_UPSELL_TOKEN_FROM_GOOGLE, getUpsellTokenFromGoogle);
}
function* watchGetUpsellTokenFromMicrosoft() {
  yield takeLatest(GET_UPSELL_TOKEN_FROM_MICROSOFT, getUpsellTokenFromMicrosoft);
}

function* watchGetCurrentUserInfos() {
  yield takeLatest(GET_CURRENT_USER_INFOS, getCurrentUserInfos);
}

function* watchLogout() {
  yield takeLatest(AUTH_LOGOUT, postLogout);
}

export default function* root() {
  yield all([
    fork(watchGetUpsellTokenFromGoogle),
    fork(watchGetUpsellTokenFromMicrosoft),
    fork(watchGetCurrentUserInfos),
    fork(watchLogout)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/authSagas.js